import React, { useCallback, useState } from 'react';
import useProductUpdates from 'hooks/useProductUpdates.jsx';
import { styled } from '@linaria/react';
import { ProductUpdateItem } from './ProductUpdateItem.jsx';

const ProductUpdatesWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 0 10px;
`;

const ItemWrapper = styled.div`
  width: 100%;
  flex-shrink: 1;
  border-radius: 25px;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.10);
  overflow: hidden;
`;

export const ProductUpdates = () => {
  const { isLoading, isError, items = [] } = useProductUpdates();

  // Load items incrementally
  const [ loadIndex, setLoadIndex ] = useState(0);
  const onNextItemLoad = useCallback(() => {
    setLoadIndex(prev => prev + 1);
  }, []);

  return (
    <ProductUpdatesWrapper>
      {!isLoading && !isError && items.length && (
        <ListWrapper>
          {items.map((it, i) => {
            // Wipe the text for all items after the first loaded item to force them
            // to stay unloaded until all previous items have been loaded
            const item = {
              ...it,
              ...(i > loadIndex && { text: null }),
            };
            return (
              <ItemWrapper key={item.title}>
                <ProductUpdateItem index={i} {...item} onLoad={loadIndex === i && onNextItemLoad} />
              </ItemWrapper>
            );
          })}
        </ListWrapper>
      )}
    </ProductUpdatesWrapper>
  );
};
